import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { header_sub_menu_edit_template } from "../components/templates/header_sub_menu_edit_template";
import { header } from "./header";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { ID_BRAND } from "../utils/consts/brand";

declare var ko: any;
declare var page: any;

export class header_sub_menu_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected headerSubMenu: header_sub_menu_edit_template;
    protected pagination: pagination_template;
    protected saveAndStay = false;
    protected editingTimerDuration = 1800000; // 30 minutes
    //protected editingTimerDuration = 30000; // 30 seconds for debug
    protected editingTimerReference: any; 

    buildContent(): Array<Element> {
        this.headerSubMenu = new header_sub_menu_edit_template("headerSubMenu", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Header Menu");

        return [ this.headerSubMenu.build()];

    }

    protected getModuleName(): string {
        return "header_sub_menu_edit";
    }

    public fillPage() : void{

        this.getFormData();
    }

    protected getFormData() {
        this.loadingIn(this.headerSubMenu.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idMenu = this.getVnAppZone().app.params.id;

        let usrReq_url: string = '/api/brand/' + idBrand + "/menu/get/"+ idMenu+"/";
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push([
            "data", JSON.stringify({
                orderBy: "idParent",
                orderByDirection: 'ASC'
            })
        ]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetFormDataReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed[0].data;
                obj.viewModel.headerSubMenu.itemsToDelete([]);
                obj.headerSubMenu.setMenuItems(data,parseInt(responseParsed.maxId),responseParsed.menuStyle);
                obj.headerSubMenu.setPermissions(responseParsed.permissions);
                obj.headerSubMenu.setIsDefaultMenu(responseParsed.isDefaultMenu);
                obj.headerSubMenu.setIsMltBrand(Number(obj.getVnAppZone().getApp().params.idBrand) === ID_BRAND.MLT);
                obj.loadingOut(obj.headerSubMenu.builtTemplate);

            })

        }
    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/header-menu/");

    }
    public setIsImageOptimized(val) {}

    public getSuggestions(keyword, idSourceElement) {

        if(idSourceElement == "filterAutocompleteCategory_template"){
            this.getCategorySuggestion(keyword);
        } else {
            this.getTagSuggestions(keyword);
        }
    }
    
    private getTagSuggestions(keyword) {

        this.XHRHdl.cancelAndReset();

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}};
        let usrReq_url: string = '/api/search/tag/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {


                let response = JSON.parse(req.request.response);

                if (response.data.tags) {

                    response.data.tags.forEach(tag => {
                        tag.name += ` ${tag.formattedDataset}`;
                    })
                    // obj.editForm.setTagTypeFilter(response.data.idElement, response.data.tagTypes);
                    let tagOptions = obj.removeAlreadySelectedTags(response.data.tags);
                    obj.headerSubMenu.tagFilter.setOptions(tagOptions);
                }

            });
        }
    }

    private getCategorySuggestion(keyword) {

        this.XHRHdl.cancelAndReset();

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/search/menu_categories/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetCategorySuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetCategorySuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                if(response){
                    obj.headerSubMenu.categoryFilter.setOptions(response);
                }
            });
        }
    }

    public onAutocompleteInputClick(idElement) {

        if (idElement == "filterAutocompleteCategory_template") {
            let categoryFilter = this.headerSubMenu.categoryFilter.getTemplateViewModel();
            if(categoryFilter.addNewSelected()){
                this.headerSubMenu.categoryFilter.setOptions([]);
            }
        } else {
            let contentTypeFilter = this.headerSubMenu.tagFilter.getTemplateViewModel();
            if(contentTypeFilter.addNewSelected()){
                this.headerSubMenu.tagFilter.setOptions([]);
            }
        }
    }

    //The options won't have already selected tags
    public removeAlreadySelectedTags(optionTags){
        let items = this.headerSubMenu.getTemplateViewModel().items();
        let currentTags = [];

        items.forEach(item => {
            if(item.tags){
                item.tags.forEach(tag => {
                    if(typeof(tag.id) == 'function'){
                        currentTags.push(parseInt(tag.id()));
                    }else{
                        currentTags.push(parseInt(tag.id));
                    }
                    
                })
            }
        });

        let optionsNotInCurrentTags = optionTags.filter(optionTag => {
            
            return  currentTags.indexOf(parseInt(optionTag.id)) === -1
        });
        
        return optionsNotInCurrentTags;
        
    }

    public onAutocompleteOptionChange(idElement) {

        if (idElement == "filterAutocompleteCategory_template") {
            let category = this.headerSubMenu.categoryFilter.getTemplateViewModel().optionObj();
            if (category) {
                let categoryArray = this.headerSubMenu.getTemplateViewModel().categories();
                let addCategory = true;
                for(let i = 0; i < categoryArray.length; i++){
                    if(categoryArray[i].id() == category.id){
                        addCategory = false;
                        break;
                    }
                }
                if(addCategory){
                    categoryArray.push(category);
                    this.headerSubMenu.setCategories(categoryArray);
                }
                this.headerSubMenu.categoryFilter.clearSelectedOption();
            }
        } else {
            let tag = this.headerSubMenu.tagFilter.getTemplateViewModel().optionObj();
            if (tag) {
                let tagArray = this.headerSubMenu.getTemplateViewModel().tags();
                let currentTags = this.headerSubMenu.getTemplateViewModel().oldTags().concat(this.headerSubMenu.getTemplateViewModel().oldTags());
                let addTag = true;
                for(let i =0; i<currentTags.length; i++){
                    if(currentTags[i].id == tag.id){
                        addTag = false;
                        break;
                    }
                }
                if(addTag){
                    tagArray.push(tag);                    
                    this.headerSubMenu.setTags(tagArray);
                }
                this.headerSubMenu.tagFilter.clearSelectedOption();
            }
        }
        
    }

    public onAutocompleteInputClear(idElement) {

        this.headerSubMenu.tagFilter.setOptions([]);

        if (this.headerSubMenu.tagFilter.getTemplateViewModel().optionObj()) {
            this.headerSubMenu.tagFilter.clearInput();
            this.headerSubMenu.tagFilter.getTemplateViewModel().clearSelectedOption();
        }
        if(this.headerSubMenu.getTemplateViewModel().tags()){
            this.headerSubMenu.getTemplateViewModel().tags(null);
        }
    }

    private extractViewModelData(viewModel) {
        let headerSubMenu = this.viewModel.headerSubMenu;
        return {
            headerSubMenu:{
                items: headerSubMenu.items() || [],
                itemsToDelete: headerSubMenu.itemsToDelete() || [],
                maxId: headerSubMenu.maxId() || 0,
                menuName: headerSubMenu.menuName() || '',
                showActionId: headerSubMenu.showActionId(),
                deleteConfirmation: headerSubMenu.deleteConfirmation(),
                canSetSection: headerSubMenu.canSetSection() || false,
                canSetStyling: headerSubMenu.canSetStyling() || false,
                showAddForm: headerSubMenu.showAddForm() || false,
                addPosition: headerSubMenu.addPosition(),
                siblingOrder: headerSubMenu.siblingOrder(),
                siblingParent: headerSubMenu.siblingParent(),
                itemId: headerSubMenu.itemId(),
                rootItems: headerSubMenu.rootItems() || [],
                menuStyle: headerSubMenu.menuStyle(),
                pageId: headerSubMenu.pageId(),
                temporaryHolder: headerSubMenu.temporaryHolder() || [],
                tag: headerSubMenu.tags() || [],
                categories: headerSubMenu.categories() || [],
                permissions: headerSubMenu.permissions() || [],
                inSubMenu: headerSubMenu.inSubMenu() || false,
                clickedItem: headerSubMenu.clickedItem(),
                filteredItems: headerSubMenu.filteredItems() || [],
                errorMessage: headerSubMenu.errorMessage(),
                removedTags: headerSubMenu.removedTags() || [],
            }
        };
    }

    public save(option : string){

        this.loadingIn(this.headerSubMenu.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idMenu = this.getVnAppZone().getApp().params.id;

        let formReq_url: string = '/api/brand/' + idBrand + "/menu/save/";

        let formReq_params: Array<Array<string>> = [];

        //Going to update the items if this is in sub-subMenu
        if(this.headerSubMenu.getTemplateViewModel().inSubMenu()){
            //This function copies the items to the items observable
            this.headerSubMenu.onBackActionToSubMenu(true);
        }
        if(option === 'stay'){
            this.saveAndStay = true;
        }


        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        let subViewModel = this.extractViewModelData(this.viewModel.headerSubMenu);
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        formReq_params.push(["menu",ko.toJSON({idMenu : idMenu, saveAndStay: this.saveAndStay})]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Sub-Menu saved successfully !");
                    
                    if (!obj.saveAndStay) {
                        page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/config/header-menu/');
                        obj.stopEditingTimer();
                    }
                    obj.saveAndStay = false;

                    obj.viewModel.headerSubMenu.itemsToDelete([]);
                });
                obj.loadingOut(obj.headerSubMenu.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public filterSimpleCancel(){
        this.headerSubMenu.onClickCancelSearch();
    }

    public cancel(){
        page('/brand/' + this.getVnAppZone().getApp().params.idBrand + '/config/header-menu/');
    }

    public filterSimpleOnChange(item){
        this.headerSubMenu.onKeyUpFilterAction();
    }

    protected getImagePickerHelper() {
        return this.headerSubMenu.imagePickerHelper;
    }

    public valnetLocker(item, requestType){

        this.loadingIn(this.headerSubMenu.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idMenu = this.getVnAppZone().getApp().params.id;

        let formReq_url: string = '/api/brand/' + idBrand + "/menu/valnet_locker/";

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {id: item, requestType: requestType};
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        //formReq_params.push(["menu",ko.toJSON({idMenu : idMenu})]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let response = JSON.parse(req.request.response);
                    if(response.locked && !response.lockedByUser){

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Sub-Menu is being edited by "+response.lockedBy);
                        obj.headerSubMenu.restoreOriginalState(obj.headerSubMenu.getTemplateViewModel().temporaryHolder(),obj.headerSubMenu.getTemplateViewModel().maxId());
                        obj.getVnAppZone().showNotificationToModule();
                    }else if(!response.locked && response.lockedByUser){
                        obj.startEditingTimer();
                    }else{
                        //obj.backActionToSubMenu();
                    }
                    
                });
                obj.loadingOut(obj.headerSubMenu.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public backActionToSubMenu(){
        
        this.headerSubMenu.getTemplateViewModel().onBackActionToSubMenu(true);
    }

    protected startEditingTimer(): void {
        const startTime = Date.now();
    
        // Clear any existing timer
        if (this.editingTimerReference) {
            clearInterval(this.editingTimerReference);
        }
    
        console.log("Starting the timer...");
    
        this.editingTimerReference = setInterval(() => {
            const elapsedTime = Date.now() - startTime;
    
            //console.log(`Elapsed time: ${elapsedTime / 1000} seconds`);
    
            // Check if the elapsed time exceeds the timer duration
            if (elapsedTime >= this.editingTimerDuration) {
                this.headerSubMenu.stillEditing();
                clearInterval(this.editingTimerReference);
                //console.log("Timer completed: 30 seconds");
            }
        }, 1000); // Check every second
    }
    

    protected stopEditingTimer(): void {
        if (this.editingTimerReference) {
            clearInterval(this.editingTimerReference);
            this.editingTimerReference = null;
            console.log("Timer stopped.");
        }
    }

}


// WEBPACK FOOTER //
// ./js/modules/header_sub_menu_edit.ts